import React from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import PartnersSection from './PartnersSection';

const PartnersMain = () => {
  return (
    <main>
      <Breadcrumb  subtitle="About" title="Strategic Partners"/>
      <PartnersSection/>
    </main>
  );
};
export default PartnersMain;